export default __webpack_public_path__ + "7b34aa8a1ffc3ddf7c4fa3c18671dbc3.jpg";